import React from 'react';
import { connect } from 'react-redux';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { MainColumn } from 'apps/auth/components/common/Layout/MainColumn/MainColumn';
import { Row } from 'apps/auth/components/common/Layout/Row';
import Notification from 'apps/auth/components/history/Notification';
import PaysendPlusBanner from 'apps/auth/components/paysendPlus/PaysendPlusBanner';
import { amplitudeEventForGetCardFromCards } from 'apps/auth/components/utils/AmplitudeUtils';
import { AUTH_GA_CARD_EXPIRED_NOTIFICATION, AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW } from 'apps/auth/constants/UrlConstants';

import PanelForCardList from './PanelForCardList';

const getInfoCards = (cardsArray = []) => {
    let info = {
        plastic: {},
        virtual: {},
    };
    if (cardsArray.length > 0) {
        cardsArray.forEach((card) => {
            const isExpired = !card.pendingActivation && (Boolean(card.expiredSoon) || card.expired);
            if (card.virtual) {
                info.virtual.hasVirtual = card.virtual;
                info.virtual.hasExpiredVirtual = info.virtual.hasExpiredVirtual || isExpired;
            }
            if (card.plastic) {
                info.plastic.hasPlastic = card.plastic;
                info.plastic.hasExpiredPlastic = info.plastic.hasExpiredPlastic || isExpired;
                info.plastic.hasPendingActivationPlastic = info.plastic.hasPendingActivationPlastic || card.pendingActivation;
            }
        });
    }
    return info;
};

const ListCardsGA = (props) => {
    const {
        virtual: { hasVirtual = false, hasExpiredVirtual = false },
    } = getInfoCards(props.cards);
    const isReissueVirtualCard = hasExpiredVirtual;
    const isGetVirtualCard = !hasVirtual;

    const getCardsTitle = () => {
        if (isReissueVirtualCard) {
            return props.reissueVirtualCard;
        } else if (isGetVirtualCard) {
            return props.getVirtualCard;
        }
        return '';
    };

    const getHref = () => {
        if (isReissueVirtualCard) {
            return AUTH_GA_CARD_EXPIRED_NOTIFICATION;
        } else if (isGetVirtualCard) {
            return AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW;
        }
        return '';
    };

    return (
        <>
            <MainColumn>
                <Notification />
                <HeaderPanel
                    title={props.titleCard}
                    buttonRowCaption={getCardsTitle()}
                    buttonRowType="link"
                    buttonRowHref={getHref()}
                    buttonRowOnClick={amplitudeEventForGetCardFromCards}
                />
                {props.paysendPlusBannerEnabled && (
                    <Row flex justify="center" indent="48px">
                        <PaysendPlusBanner />
                    </Row>
                )}
                <PanelForCardList cards={props.cards} orderedCardTitle={props.orderedCardTitle} />
            </MainColumn>
        </>
    );
};

const mapStateToProps = ({ messages, extra }) => {
    return {
        titleCard: messages.pageMessages.titleCard,
        cards: extra.cards,
        isLibre: extra.isLibre,
        paysendPlusBannerEnabled: extra.paysendPlusBannerEnabled,
        getVirtualCard: messages.pageMessages.getVirtualCard,
        reissueVirtualCard: messages.pageMessages.reissueVirtualCard,
        orderedCardTitle: messages.pageMessages.orderedCardTitle,
    };
};
export default connect(mapStateToProps)(ListCardsGA);
